import React, { useEffect, useState } from "react";
import "../Styles/SettingPage.css";
import MenuBar from "./MenuBar";
import { clearAllData, getData } from "../utils/store-data";
import { useNavigate } from "react-router-dom";
import { AGENT_LOGIN, USER_ID } from "../utils/store-data-constants";
import { get_agent, get_client, get_user_byid } from "../api/serverWrapper";

export default function SettingsPage() {
  let [IsAgent, setIsAgent] = useState(true);
  const [BusinessDetails, setBusinessDetails] = useState(null);
  const [clientDetails, setClientDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadIntitalData();
  }, []);

  const loadIntitalData = async () => {
    try {
      setIsLoading(true);

      let id = await getData(USER_ID);
      let agentresp = await getData(AGENT_LOGIN);
      IsAgent = agentresp;
      setIsAgent(IsAgent);

      let resp = await get_client(id);
      let agent_resp = await get_agent(id);

      console.log(agent_resp.data, resp.data);
      setBusinessDetails(agent_resp.data);

      setClientDetails(resp.data);
    } catch (error) {
      console.error("Failed to load settings data", error);
    } finally {
      setIsLoading(false);
    }
  };

  const navigate = useNavigate();

  const LogOut = async () => {
    await clearAllData();
    navigate("/home");
  };

  const editAgent = () => {
    navigate("/editBusiness_set_up", {
      state: { existingAgent: BusinessDetails },
    });
  };
  const editClient = () => {
    console.log(clientDetails);
    // if(clientDetails?.ParentId){
    navigate("/edit-client", { state: clientDetails });
    // }
  };

  return (
    <div className="main-wrapper">
      <MenuBar />

      <div className="otp-page">
        {/* Left Panel */}
        <div className="left-panel">
          <img
            src={require("../assests/images/otp_verification_logo.png")}
            alt="WedLuk Logo"
            className="logo"
          />
          <p className="tagline">Matirmonial Nexus</p>
        </div>

        {/* Right Panel */}
        {isLoading ? (
          <div className="right-panel">
            <div className="welcome-container settings-loading">
              <div className="settings-spinner" />
              <p className="welcome-subtext">Loading your profile...</p>
            </div>
          </div>
        ) : IsAgent ? (
          <div className="right-panel">
            <div className="welcome-container">
              {/* Profile Image */}
              <div className="profile-pic" onClick={editAgent}>
                {BusinessDetails?.User?.ProfilePhotoUrl ? (
                  <img
                    src={BusinessDetails?.User?.ProfilePhotoUrl}
                    alt={"Agnet"}
                  />
                ) : (
                  <img
                    src={
                      BusinessDetails?.User?.Gender === 1
                        ? require("../assests/images/MaleDefaultIcon.png")
                        : require("../assests/images/FeMaleDefaultIcon.png")
                    }
                    alt={"jjj"}
                  />
                )}
              </div>

              {/* Welcome Text */}
              <h1 className="welcome-title mt-4">
                Welcome {BusinessDetails?.User?.FirstName}{" "}
                {BusinessDetails?.User?.LastName}!
              </h1>
              <p className="welcome-subtext">
                Get started by adding your client profiles
              </p>
            </div>
            <div className="otp-card" onClick={LogOut}>
              <button className="login-btn">Log Out →</button>
            </div>
          </div>
        ) : (
          <div className="right-panel">
            {clientDetails && (
              <div className="welcome-container">
                {/* Profile Image */}
                <div
                  className="profile-pic"
                  onClick={() => {
                    if (clientDetails) {
                      editClient();
                    }
                  }}
                >
                  {clientDetails?.ProfilePhotoUrl ? (
                    <img src={clientDetails?.ProfilePhotoUrl} alt={"client"} />
                  ) : (
                    <img
                      src={
                        clientDetails?.Gender === 1
                          ? require("../assests/images/MaleDefaultIcon.png")
                          : require("../assests/images/FeMaleDefaultIcon.png")
                      }
                      alt={"jjj"}
                    />
                  )}
                </div>

                {/* Welcome Text */}
                <h1 className="welcome-title">
                  Welcome {clientDetails?.FirstName} {clientDetails?.LastName}!
                </h1>
                <p className="welcome-subtext">
                  Get started by adding your profiles
                </p>
              </div>
            )}
            {/* <div className="otp-card" onClick={LogOut}>
              <button className="login-btn">Log Out →</button>
            </div> */}
          </div>
        )}
      </div>
    </div>
  );
}